export default "__VITE_ASSET__BNJCzd0k__"